if ($('.js-owl-banner').length) {
  $('.js-owl-banner').owlCarousel({
    items: 1,
    autoplay: true,
    loop: true,
    dots: true,
    nav: false,
    margin: 0
  });
};

if ($('.js-owl-feature').length) {
  $('.js-owl-feature').owlCarousel({
    items: 4,
    autoplay: true,
    loop: true,
    dots: false,
    nav: true,
    margin: 20,
    navText: [`<i class="fa fa-angle-left"></i>`,
      `<i class="fa fa-angle-right"></i>`
    ],
    responsive: {
      0: {
        items: 2,
        nav: false
      },
      500: {
        items: 3,
        nav: true
      },
      1000: {
        items: 4
      }
    }
  });
};

if ($('.js-owl-latest').length) {
  $('.js-owl-latest').owlCarousel({
    center: true,
    items: 3,
    autoplay: true,
    loop: true,
    dots: false,
    nav: false,
    margin: 20,
    navText: [`<i class="fa fa-angle-left"></i>`,
      `<i class="fa fa-angle-right"></i>`
    ],
    responsive: {
      0: {
        items: 1,
        center: true,
      },
      768: {
        items: 3
      }
    }
  });
};
if ($('.js-owl-related').length) {
  $('.js-owl-related').owlCarousel({
    items: 4,
    autoplay: true,
    loop: true,
    dots: false,
    nav: false,
    margin: 20,
    navText: [`<i class="fa fa-angle-left"></i>`,
      `<i class="fa fa-angle-right"></i>`
    ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      768: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  });
};
if ($('.js-owl-thumbnail').length) {
  $('.js-owl-thumbnail').owlCarousel({
    items: 5,
    autoplay: false,
    loop: false,
    mouseDrag: false,
    dots: false,
    nav: true,
    smartSpeed: 1000,
    navContainer: $('.js-owl-thumbnail-nav'),
    navText: [`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="6.3px"
       height="11.8px" viewBox="0 0 6.3 11.8" enable-background="new 0 0 6.3 11.8" xml:space="preserve">
    <polygon points="5.9,11.8 0,5.9 5.9,0 6.2,0.4 0.7,5.9 6.3,11.5 "/>
    </svg>`, `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="6.3px"
     height="11.8px" viewBox="0 0 6.3 11.8" enable-background="new 0 0 6.3 11.8" xml:space="preserve">
   <polygon points="0.4,11.8 6.3,5.9 0.4,0 0,0.4 5.6,5.9 0,11.5 "/>
   </svg>`],
    margin: 10,
    responsive: {
      0: {
        items: 3
      },
      900: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  });
};
if ($('.js-owl-video').length) {
  $('.js-owl-video').owlCarousel({
    items: 1,
    autoplay: true,
    loop: true,
    dots: true,
    nav: false,
    margin: 0
  });
};

if ($('.js-owl-thumblist').length) {
  $('.js-owl-thumblist').owlCarousel({
    items: 5,
    autoplay: false,
    loop: false,
    dots: false,
    nav: false,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3
      },
      768: {
        items: 4
      },
      1000: {
        items: 5
      },
      1200: {
        items: 6
      }
    }
  });
};

$('.js-thumbnail-block a').click(function(e) {
  e.preventDefault();
  var $self = $(this);
  var image = $self.attr('data-zoom');
  $('.js-thumbnail-block a').parent().removeClass('active');
  $('.image-zoom').attr('src', image);
  $self.parent().addClass('active');
});

$('.block-header .block-search button[type="button"]').click(function(e) {
  e.preventDefault();
  $('.block-header .block-search').toggleClass('__expanded');
});

$('.js-scroll').click(function(e) {
  $('html,body').animate({
    scrollTop: $('#down').offset().top
  }, 1000);
})

$('.js-megamenu-nav > ul > li > a').hover(function() {
  var ths = $(this);
  var navi = ths.attr('data-navb');
  $('.js-megamenu .js-megamenu-nav li').removeClass('active');
  ths.parent().addClass('active');
  $('.js-megamenu section').attr('style', '');
  $('.js-megamenu [data-navs="' + navi + '"]').css('display', 'block');
  var mnuh = $('.js-megamenu [data-navs="' + navi + '"] > nav > ul').height();
  $('.js-megamenu-nav').css('min-height', mnuh + 32);
});

$('.js-megamenu section li')
  .mouseover(function() {
    $(this).find('ul:first').show();
  })
  .mouseout(function() {
    $(this).find('ul:first').hide();
  });

$('.js-menu').click(function(e) {
  e.preventDefault();
  $('body').toggleClass('__modal');
  $('.js-menu, .block-mobile-nav, .block-wrapper, .block-header').toggleClass(
    'active');
});
$('.js-mobile-menu li i').click(function(e) {
  e.preventDefault();
  $(this).parent().toggleClass('active');
  $(this).next().slideToggle();
});

if (typeof fancybox === "function") {
  $("[data-fancybox]").fancybox({
    buttons: [
      'slideShow',
      'fullScreen',
      'thumbs',
      'close'
    ],
  });
};
